import { faCheck, faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

type StateColumnManageJobsProps = {
    state: boolean
}

const StateColumnManageJobs = ({ state }: StateColumnManageJobsProps) => {
    return (
        state
        ? <FontAwesomeIcon icon={faCheck} className={"c-black"} />
        : <FontAwesomeIcon icon={faX} className={"c-manatee"} />
    )
}

export default React.memo( StateColumnManageJobs )